import React, { useRef } from 'react';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';

import { MAX_SCALE, MIN_SCALE } from './constants';
import { ScaleBar } from './scaleBar';
import { ScaleContainerProps } from './ScaleContainer.interface';

export const ScaleContainer: React.FC<ScaleContainerProps> = ({
  children,
  enableScaleControls = false,
  containerStyle = {},
  wrapperStyle = {},
  contentStyle = {},
  contentWrapperStyle = {},
  scaleBarStyles = {},
}) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  return (
    <div
      ref={wrapperRef}
      style={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
        ...containerStyle,
      }}>
      <TransformWrapper
        minScale={MIN_SCALE}
        maxScale={MAX_SCALE}
        centerOnInit
        limitToBounds
        disabled={!enableScaleControls}
        wheel={{ disabled: !enableScaleControls }}>
        {() => (
          <>
            <TransformComponent
              wrapperStyle={{
                flex: 1,
                display: 'flex',
                maxHeight: '100%',
                background: 'white',
                width: '100%',
                ...wrapperStyle,
              }}
              contentStyle={{
                minWidth: 'fit-content',
                minHeight: 'fit-content',
                ...contentStyle,
              }}>
              <div style={{ ...contentWrapperStyle }} ref={contentRef}>
                {children}
              </div>
            </TransformComponent>
            <ScaleBar
              wrapperRef={wrapperRef}
              contentRef={contentRef}
              showScaleControls={enableScaleControls}
              watchValue={children}
              scaleBarStyles={scaleBarStyles}
            />
          </>
        )}
      </TransformWrapper>
    </div>
  );
};
